/* assets/quick-view.js */
(function () {
  const overlay = document.getElementById('quickview-overlay');
  if (!overlay) return;

  const sheet = overlay.querySelector('.qv-overlay__sheet');
  const container = overlay.querySelector('.qv-overlay__content');

  let bodyScrollTop = 0;

  /* --------------------------
   * Utilities
   * ------------------------*/

  function findCardWrapper(el) {
    return el.closest('.product-card-wrapper') || el.closest('.card-wrapper') || el;
  }

  function getStickyHeaderOffset() {
    const header = document.querySelector('.section-header, .header-wrapper, header');
    return header ? header.getBoundingClientRect().height : 0;
  }

  // Smooth scroll to element (accounting for sticky header). Resolves when “settled”.
function smoothScrollToEl(el) {
  return new Promise((resolve) => {
    if (!el) { resolve(); return; }

    const offset = -getStickyHeaderOffset();
    const targetY = Math.max(
      0,
      el.getBoundingClientRect().top + window.pageYOffset + offset
    );

    const startY = window.pageYOffset;
    const delta  = Math.abs(startY - targetY);

    // If we're already at (or basically at) the target, don't wait on scroll at all.
    if (delta <= 1) {
      resolve();
      return;
    }

    // Always use a requestAnimationFrame polling fallback — reliable everywhere.
    const tolerance = 2;
    let lastY = startY;
    let stillFrames = 0;

    function check() {
      const y = window.pageYOffset;

      // Close enough to target => done
      if (Math.abs(y - targetY) <= tolerance) {
        resolve();
        return;
      }

      // If scroll position isn't changing for several frames, bail out anyway
      if (y === lastY) {
        stillFrames += 1;
        if (stillFrames > 12) { // ~200ms at 60fps
          resolve();
          return;
        }
      } else {
        stillFrames = 0;
      }

      lastY = y;
      requestAnimationFrame(check);
    }

    window.scrollTo({ top: targetY, behavior: 'smooth' });
    requestAnimationFrame(check);
  });
}


  function lockBody() {
    bodyScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    document.body.classList.add('qv-lock');
    // Prevent layout shift on scrollbar disappearance
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) {
      document.documentElement.style.setProperty('--qv-scrollbar', `${scrollbarWidth}px`);
      document.body.style.marginRight = `var(--qv-scrollbar)`;
    }
  }

  function unlockBody() {
    document.body.classList.remove('qv-lock');
    document.body.style.marginRight = '';
    window.scrollTo({ top: bodyScrollTop });
  }

  /* --------------------------
   * Cart UI helpers
   * ------------------------*/

  // Re-render the cart icon bubble via the cart-icon-bubble section
  function updateCartBubbleFromSections(sectionsData) {
    // Dawn has a dedicated cart-icon-bubble section
    const wrapper =
      document.querySelector('[data-cart-icon-bubble]') ||
      document.getElementById('cart-icon-bubble');

    if (!wrapper) return;
    const html = sectionsData && sectionsData['cart-icon-bubble'];
    if (!html) return;

    // If wrapper is the section container, replace its inner HTML
    wrapper.innerHTML = html;
  }

  // Fallback: fetch the cart-icon-bubble section directly
  function fetchAndUpdateCartBubble() {
    fetch('/?sections=cart-icon-bubble')
      .then((res) => res.json())
      .then((data) => {
        updateCartBubbleFromSections(data);
      })
      .catch((e) => console.error('Quick view: cart bubble update failed', e));
  }

  /* --------------------------
   * Variant syncing
   * ------------------------*/
  function hookVariantChange(form) {
    const selects = form.querySelectorAll('.qv__select');
    const variantIdInput = form.querySelector('input.product-variant-id');
    if (!selects.length || !variantIdInput) return;

    const action = form.getAttribute('action') || '';
    const handle = action.split('/products/')[1]?.split('?')[0];
    let productData = null;

    async function ensureData() {
      if (productData || !handle) return productData;
      try {
        const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
        productData = await res.json();
        return productData;
      } catch (e) {
        console.warn('Variant JSON fetch failed', e);
        return null;
      }
    }

    async function updateVariant() {
      await ensureData();
      if (!productData) return;

      const values = Array.from(selects).map((s) => s.value);
      const match = productData.variants.find((v) =>
        v.options.every((opt, i) => opt == values[i])
      );

      if (match) {
        variantIdInput.value = match.id;
        const btn = form.querySelector('button[name="add"]');
        if (btn) btn.disabled = !match.available;
      }
    }

    selects.forEach((s) => s.addEventListener('change', updateVariant));
    updateVariant();
  }

  /* --------------------------
   * Wire Add-to-Cart (AJAX + Dawn sections)
   * ------------------------*/

  function wireQuickViewForm(form) {
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const variantInput = form.querySelector('input.product-variant-id');
      if (!variantInput || !variantInput.value) {
        console.warn('Quick view: no variant id');
        return;
      }

      const submitBtn = form.querySelector('button[name="add"]');
      if (submitBtn) submitBtn.disabled = true;

      const quantityInput = form.querySelector('[name="quantity"]');
      let quantity = parseInt(quantityInput && quantityInput.value, 10);
      if (!quantity || quantity < 1) quantity = 1;

      const payload = {
        items: [
          {
            id: Number(variantInput.value),
            quantity: quantity
          }
        ],
        // Ask Shopify to return the UI sections Dawn uses
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      };

      const addUrl =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(addUrl + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload),
        credentials: 'same-origin'
      })
        .then((res) => res.json())
        .then((data) => {
          // 1) Update header cart icon bubble
          if (data.sections) {
            updateCartBubbleFromSections(data.sections);
          } else {
            fetchAndUpdateCartBubble();
          }

          // 2) Update / open Dawn cart drawer if present
          const cartDrawer =
            document.querySelector('cart-drawer') ||
            document.querySelector('cart-notification');

          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            try {
              cartDrawer.renderContents(data);
              cartDrawer.classList.remove('is-empty');
            } catch (err) {
              console.warn('Quick view: cart drawer render failed', err);
            }
          }

          closeQuickView();
        })
        .catch((err) => {
          console.error('Quick view add-to-cart failed', err);
        })
        .finally(() => {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

    /* --------------------------
   * Quick-view media slider
   * ------------------------*/
  function wireQuickViewSlider(root) {
    if (!root) return;

    const slider = root.querySelector('[data-qv-slider]');
    if (!slider) return;

    const slides = slider.querySelectorAll('.qv__media-slide');
    if (!slides.length) return;

    let current = 0;

    function show(index) {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length; // wrap around
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === current);
      });
    }

    const prevBtn = slider.querySelector('.qv__media-nav--prev');
    const nextBtn = slider.querySelector('.qv__media-nav--next');

    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        show(current - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        show(current + 1);
      });
    }

    // Ensure the first slide is visible on init
    show(0);
  }


  /* --------------------------
   * Open / Close
   * ------------------------*/

  async function openQuickView(productUrl, originEl) {
    try {
      // Build section-render URL
      const url = new URL(productUrl, window.location.origin);
      url.searchParams.set('section_id', 'quick-view');

      // Start fetch and scroll concurrently
      const fetchHTML = fetch(url.toString(), { credentials: 'same-origin' }).then((r) =>
        r.text()
      );
      const doScroll = smoothScrollToEl(findCardWrapper(originEl));

      const [html] = await Promise.all([fetchHTML, doScroll]);

      // Inject content
      container.innerHTML = html;

      // Hook close button from injected HTML
      const closeBtn = container.querySelector('.qv__close');
      if (closeBtn) closeBtn.addEventListener('click', closeQuickView);

      // Variant syncing
      const form = container.querySelector('form.qv__form');
      if (form) {
        hookVariantChange(form);
        wireQuickViewForm(form); // <-- NEW: Ajax add-to-cart + UI update
      }

      wireQuickViewSlider(container);

      // Show overlay *after* scroll has parked us at the card
      overlay.hidden = false;
      requestAnimationFrame(() => {
        overlay.classList.add('is-open');
      });

      // Lock background scroll
      lockBody();

      // Close handlers
      document.addEventListener('keydown', onEsc);
      overlay.addEventListener('click', onBackDrop);

      // Prevent clicks inside sheet from bubbling to backdrop
      if (sheet) {
        sheet.addEventListener('click', (e) => e.stopPropagation());
      }
    } catch (e) {
      console.error('Quick view failed:', e);
    }
  }

  function closeQuickView() {
    overlay.classList.remove('is-open');
    // Match your CSS transition time (300ms by default)
    setTimeout(() => {
      overlay.hidden = true;
      container.innerHTML = '';
      unlockBody();
      document.removeEventListener('keydown', onEsc);
      overlay.removeEventListener('click', onBackDrop);
    }, 300);
  }

  function onEsc(e) {
    if (e.key === 'Escape') closeQuickView();
  }

  function onBackDrop(e) {
    // Only when backdrop itself is clicked (sheet click is stopped)
    if (e.target === overlay) closeQuickView();
  }

  /* --------------------------
   * Click interception
   * ------------------------*/

  document.addEventListener(
    'click',
    function (e) {
      // Clicks on typical Dawn product links inside cards
      const link = e.target.closest(
        '.card__heading .full-unstyled-link, .card__content .full-unstyled-link'
      );
      if (!link) return;

      const href = link.getAttribute('href');
      if (!href) return;

      const url = new URL(href, window.location.origin);
      if (!/\/products\//.test(url.pathname)) return; // ignore non-product links

      // Avoid hijacking real buttons (e.g., quick add) inside the card
      if (e.target.closest('button, [role="button"]')) return;

      e.preventDefault();
      openQuickView(url.toString(), link);
    },
    true
  );

  // Optional: expose close for inline onclicks in your section
  window.closeQuickView = closeQuickView;
})();
